import { useCallback } from 'react';
import type { CalendarEvent } from '~/src/types/api';

export const useMergeEventsWithDelta = () => {
  return useCallback(
    (
      previousEvents: CalendarEvent[],
      deltaEvents: CalendarEvent[],
      provider: 'google' | 'microsoft',
    ): CalendarEvent[] => {
      const mergedEvents = new Map(previousEvents.map((event) => [event.id, event]));

      for (const rawDeltaEvent of deltaEvents) {
        const deltaEvent = rawDeltaEvent as CalendarEvent & Record<string, unknown>;
        if (!deltaEvent.id) {
          continue;
        }

        const isDeleted =
          deltaEvent.status === 'cancelled' ||
          deltaEvent.isCancelled === true ||
          Boolean(deltaEvent['@removed']);

        if (isDeleted) {
          mergedEvents.delete(deltaEvent.id);
          continue;
        }

        mergedEvents.set(deltaEvent.id, {
          ...(mergedEvents.get(deltaEvent.id) ?? {}),
          ...deltaEvent,
          provider,
        });
      }

      return Array.from(mergedEvents.values());
    },
    [],
  );
};
